import { useRef, useState } from "react";

const CustomInput = ({
  placeholder,
  type = "text",
  width = "",
  height = "52px",
  isTextarea = false,
  required = false,
  value = "",
  onChange,
  disabled = false,
  error = "",
  autoComplete = "off",
  rows = 4,
  className = "",
  classNames = "",
  suffix = "",
  textAlign = "left",
  onBlur,
  onKeyDown,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const inputRef = useRef(null);

  const handlePlaceholderClick = () => {
    setIsFocused(true);
    inputRef.current?.focus();
  };

  const hasError = Boolean(error);
  const hasSuffix = Boolean(suffix) && !isTextarea;

  return (
    <div className="relative w-full" style={{ maxWidth: width }}>
      {!isFocused && !value && placeholder && (
        <div
          className="pointer-events-none absolute left-3 text-gray-400"
          onClick={handlePlaceholderClick}
          style={{
            top: isTextarea ? "14px" : `calc(${height} / 2)`,
            transform: isTextarea ? "none" : "translateY(-50%)",
          }}
        >
          {placeholder}
          {required && <span className="ml-0.5 text-red-500">*</span>}
        </div>
      )}

      {!isTextarea ? (
        <input
          ref={inputRef}
          type={type}
          name="no-autofill"
          autoComplete={autoComplete}
          disabled={disabled}
          value={value || ""}
          onChange={(e) => onChange?.(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur?.(e);
          }}
          onKeyDown={onKeyDown}
          required={required}
          style={{ height, textAlign }}
          className={`w-full rounded-md border px-4 py-3 text-[#454545] focus:outline-blue-500 ${hasError ? "border-red-500" : "border-gray-300"
            } ${disabled ? "cursor-default bg-gray-50 opacity-50" : ""
            } ${hasSuffix ? "pr-8" : ""
            } ${className} ${classNames}`}
        />
      ) : (
        <textarea
          ref={inputRef}
          name="no-autofill"
          autoComplete={autoComplete}
          value={value}
          disabled={disabled}
          onChange={(e) => onChange?.(e.target.value)}
          onFocus={() => setIsFocused(true)}
          onBlur={(e) => {
            setIsFocused(false);
            onBlur?.(e);
          }}
          onKeyDown={onKeyDown}
          required={required}
          style={{ textAlign }}
          className={`w-full resize-none rounded-md border px-4 py-3 text-[#454545] focus:outline-blue-500 ${hasError ? "border-red-500" : "border-gray-300"
            } ${disabled ? "cursor-default bg-gray-50 opacity-50" : ""
            } ${className} ${classNames}`}
          rows={rows}
        />
      )}

      {hasSuffix && (
        <div
          className={`absolute right-3 text-sm text-gray-500 ${disabled ? "opacity-50" : ""}`}
          style={{
            top: `calc(${height} / 2)`,
            transform: "translateY(-50%)",
            pointerEvents: "none",
          }}
        >
          {suffix}
        </div>
      )}

      {hasError && <div className="text-red-500 text-sm mt-1">{error}</div>}
    </div>
  );
};

export default CustomInput;
